﻿import $ from 'jquery';
import Focus from "../utilities/focusfield";

export class ListView {
  public static showMoreRows(data: any): void {
    var $tableBody = $("#rows");

    $(".table-more-row").replaceWith($(data.Items));
    $("#item-count").html(data.Count);
  }

  public static refreshPageData(data: any): void {
    Focus.after(() => {
      $("#rows").html(data.Rows);

      if (data.FilterTabs)
        $("#filter-tabs").html(data.FilterTabs);
      if (data.TraditionalPager)
        $("#traditional-pager").html(data.TraditionalPager);

      $("#item-count").html(data.Count);
      $("#search-field").replaceWith($(data.Search));

      if (data.OnRemotePageUpdate)
        $.fn.executeFunctionByName(data.OnRemotePageUpdate, window, data);
    });
  }

  public static toggleMultiSelect(data: any): void {
    var $table = $("#rows").parent();

    $table.find("thead").replaceWith(data.TableHeading);
    $("#title-buttons").html(data.TitleButtons);
    $("#action-menu-container").html(data.ActionMenu);

    ListView.refreshPageData(data);
  }
}
